import { useMutate } from '@/shared/hooks/useMutate';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiSplitsPost } from '@/entities/splits/modules/api/splits';

export const useCreateSplit = () =>
  useMutate({
    api: apiSplitsPost,
    invalidateKeys: [queryKeys.splits.all, queryKeys.parcels.availableForSplit],
  });
